import React, { useRef, useEffect } from "react";
import $ from "jquery";
import "jquery-ui/ui/widgets/autocomplete";
import "jquery-ui/themes/base/all.css";

const Autocomplete = ({ autocompleteUrl }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!inputRef.current) return;

    $(inputRef.current).autocomplete({
      source: function (request, response) {
        $.ajax({
          url: autocompleteUrl,
          dataType: "json",
          data: { query: request.term },
          success: function (data) {
            response(
              data.map((item) => ({
                label: item.display_name,
                value: item.display_name,
                item,
              }))
            );
          },
        });
      },
      minLength: 2,
      select: function (event, ui) {
        // Populate the form fields with the selected item's data
        Object.entries(ui.item.item).forEach(([key, value]) => {
          const element = document.querySelector(`#${key}`);
          if (element) {
            element.value = value;
            // Trigger input event to notify any listeners (like phone formatters...)
            element.dispatchEvent(new Event('input', { bubbles: true }))
          }
        });
        // Optionally clear the input after selection:
        inputRef.current.value = "";
        return false;
      },
    });

    // Clean up on unmount
    return () => {
      $(inputRef.current).autocomplete("destroy");
    };
  }, [autocompleteUrl]);

  return (
    <div className="soft-shadow card text-bg-light-primary mb-4">
      <div className="card-body">
        <h5>Search for Existing Caregiver</h5>
        <div className="mb-3">
          <label htmlFor="user-search" className="form-label">
            <small>Search by name, email, or phone</small>
          </label>
          <input
            type="text"
            id="user-search"
            className="form-control"
            placeholder="Start typing to search..."
            ref={inputRef}
            autoComplete="off"
          />
        </div>
      </div>
    </div>
  );
};

export default Autocomplete;